module.exports = __webpack_public_path__ + "static/media/careGem-transparent-logo.b6577368.svg";